<template>
    <div>
        <h1>Testes Mapa</h1>

        <div class="row mb-5">
            <div class="col">
                <div class="form-group">
                  <label for="textarea_poligono">Inserir poligono</label>
                  <textarea class="form-control" name="textarea_poligono" id="textarea_poligono" rows="3" v-model="form_poligono_geojson"></textarea>
                </div>

                <button type="button" class="btn btn-primary" @click="inserirPoligono">Inserir</button>

                <button type="button" class="btn btn-primary" @click="fucaoTemporaria">converter</button>

            </div>
        </div>

        <div id="map"></div>

        <p>{{ poligono_editavel_geojson }}</p>
    </div>
</template>

<script>

export default {
    data() {
        return {
            map: null,
            form_poligono_geojson: null,
            poligono_editavel: null,
            poligono_editavel_geojson: null,

            variavel_temporaria: null,
        };
    },

    mounted() {
        this.initMap();
    },

    methods: {

        //Iniciar Mapa
        initMap() {
            this.map = new google.maps.Map(document.getElementById("map"), {
                zoom: 15,
                center: { lat: -7.878727578178001, lng: -34.82924943719058},
                mapId: "DEMO_MAP_ID",
            });
        },


        inserirPoligono(){

            const geoJsonData  = JSON.parse(this.form_poligono_geojson);

            let drawingManager;

            // Converter coordenadas GeoJSON para um array de google.maps.LatLng
            const coordinates = geoJsonData.features[0].geometry.coordinates[0].map(coord => ({ lat: coord[1], lng: coord[0] }));

            // Criar o polígono a partir dos dados GeoJSON
            this.poligono_editavel = new google.maps.Polygon({
                paths: coordinates,
                strokeColor: "#FF0000",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#FF0000",
                fillOpacity: 0.35,
                editable: true
            });

            this.poligono_editavel.setMap(this.map);

            // Ajustar o mapa para o polígono
            const bounds = new google.maps.LatLngBounds();

            coordinates.forEach((latlng) => {
                bounds.extend(latlng);
            });

            this.map.fitBounds(bounds);

        },

        transformarPoligonoEmGeoJson(polygon) {
            const geometry = {
                type: "Polygon",
                coordinates: [],
            };

            const coords = polygon
                .getPath()
                .getArray()
                .map((el) => {
                return [el.lng(), el.lat()];
                });

            geometry.coordinates = [coords];

            const feature = {
                geometry,
                type: "Feature",
                properties: {},
            };

            return feature;
        },

        fucaoTemporaria(){
            this.poligono_editavel_geojson = this.transformarPoligonoEmGeoJson(this.poligono_editavel);
        }



    }

}


</script>

<style lang="scss" scoped>

</style>
